import React from 'react'
import './footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fab, faFacebook, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import {useHistory, Link} from "react-router-dom";


const Footer = () => {
  return (
    <div className='fav__footer'>
        <div className='fav__footer-row container'>
        <div className="row">
            <div className='fav_footer-row_col-1 col-lg-4 col-md-6'>
                <h5>CONTACT</h5>
                <p><a href="mailto:hello@favdoctor.com" style={{textDecoration: "none", color:"white"}}>hello@favdoctor.com</a></p>
                <p><a href="tel:+2348145234752" style={{textDecoration: "none", color:"white"}}>+234(0) 814 5234 752</a></p>
            </div>
            <div className='fav_footer-row_col-1 col-lg-4 col-md-6'>
            <h5>ADDRESS</h5>
            <p>6 Oluokun Street, Okuta
            Elerinla Estate, Akure,
           Ondo State, Nigeria. </p>
        </div>
          
            <div className='fav_footer-row_col-1 col-lg-4 col-md-6'>
                <h5>SOCIAL</h5>
                <div className='icon'><a href="https://web.facebook.com/favdoctor" style={{textDecoration: "none", color:"white"}}><FontAwesomeIcon icon={faFacebook} /></a>
                <a href="https://twitter.com/favdoctor" style={{textDecoration: "none", color:"white"}}><FontAwesomeIcon icon={faTwitter}/></a>
                <a href="https://www.instagram.com/favdoctor/" style={{textDecoration: "none", color:"white"}}><FontAwesomeIcon icon={faInstagram}/></a></div>


            </div>
          {/*  <div className='fav_footer-row_col-1 textarea col-lg-4 col-md-6'>
                <textarea cols="10" rows="5" name="message"></textarea><br />
                <input type="submit" value="Send" />
  </div>*/}
            </div>
        </div>

    </div>
  )
}

export default Footer